import React from "react";
import styled from "styled-components";
import Title from "./Title";
import { motion } from "framer-motion";
import { useScroll } from "./useScroll";
import { contactAnimation } from "animation";
import ImageGallery from "react-image-gallery";

import party1 from "../assets/kids/party1.jpg";
import home from "assets/oakmont/Picture1.jpg";
import { lightblue, yellow } from "./color";
import TitleContact from "./TitleContact";
function ContactKnife() {
  const [element, controls] = useScroll();

  return (
    <Section id="contactknife" ref={element}>
      <div className="titleBig">
        <TitleContact value="Contact" />
      </div>
      <motion.div
        className="contact"
        variants={contactAnimation}
        animate={controls}
        transition={{
          delay: 0.03,
          type: "tween",
          duration: 0.8,
        }}
      >
        <div className="contact__title">
          <h3>Contact Detail</h3>
          {/* <h3> OAKMONT </h3> */}
        </div>
        <div className="contact__data">
          <div className="contact__data__description">
            <p className="lightblue">
              At Oakmont we specialise in finding{" "}
              <span className="yellow">small, affordable,</span> residential
              developments. We charge <span className="yellow">a one off</span>{" "}
              project management fee of $20,000 (incl GST) to manage your
              project through to completion.
            </p>
            <br />

            <p className="lightblue">
              Please note{" "}
              <span className="yellow">we are not Property Developers.</span> We
              simply find good "Flip" projects and pass them on to our property
              investor clients. Our clients own their development property at
              all times and pay all professionals involved with the development
              directly.
            </p>
            <br />

            <p className="lightblue">
              Our business relies on{" "}
              <span className="yellow">repeat business</span>. Most of our
              clients try to complete two projects per year enjoying an
              exceptional income boost.
            </p>
            <br />
            <p className="yellow">
              Phone Mike on{" "}
              <a
                href="tel:+6421881444"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                021 881 444
              </a>
            </p>
            <p className="yellow">
              Or email{" "}
              <a
                href="mailto: info@Oakmont.co.nz"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                info@Oakmont.co.nz
              </a>
            </p>
          </div>
        </div>
      </motion.div>
    </Section>
  );
}

const Section = styled.section`
 position: relative; /* Added this */
  overflow: hidden;
  min-height: 100vh;

  background: url(${home}) no-repeat center/cover;
  padding: 5rem 2rem;



.contact {
    position: absolute;
    right: 5rem;
    bottom: 3rem;
    color: var(--white-color);
    background: var(--primary-color);
    margin: 4rem auto;
    border: 2px solid ${lightblue};
    border-radius: 10px;
    height: auto;
    min-width: 20vw;
    max-width: 30vw;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    box-shadow: 0px 10px 20px rgba(173, 216, 230, 0.3), /* Soft blue glow */
                0px 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */

  &__title {
    margin-bottom: 1rem;
      h2 {
        font-size: 3rem;
        color: var(--secondary-color);
      }
      h3 {
        font-size: 2rem;
        color: var(--third-color);
        font-weight: 400;
      }

  }
  &__data {
    gap: 2rem;
    &__description {
      // border: 1px solid green;
        margin: 0 rem;
        padding: 0rem;
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 0.5rem;
        text-align: left;

        p {
          font-size: 1.2rem;
        }

        .yellow {
          color: var(--third-color);
        }

        .lightblue {
        color: var(--secondary-color);
        }

        ul {
          list-style: none;
          padding: 0;
        }

        li {
          font-size: 1.5rem;
          color: var(--third-color);
          margin-bottom: 0.5rem;
        }
    }
    &__form {

      .div{
        background: var(--third-color);
        height: 300px;
      }
      }
    }
  }
}
@media screen and (min-width: 280px) and (max-width: 1080px) { 
  .contact {
    position: relative;
    min-width: 95vw;
    height: auto;
    margin-left: 3.7rem;
    padding: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    &__title {
      margin: 0;
      align-items:center;
      text-align: center;
      p {
        font-size: 0.8rem;
        width: 80%;
      }
      h2 {
        font-size: 1.5rem;
        text-align: center;
      }

      h3 {
        font-size: 2rem;
        text-align: center;
      }
    }
    &__data {
      max-width: 100%;
      p {
        text-align: left;
        margin: 0rem;
      }
        &__description {
      padding: 0rem;
      gap: 1rem;
      margin-top: 1rem;
      h4 {
        font-size: 1rem;
        color: var(--secondary-color);
      };

      p {
        text-align: left;
        font-size: 1.1rem;
      }
      div {
        p {
          strong {
            color: var(--third-color);
            font-size: 1.1rem;
          }
        }
      }
    }

      }
    }
  }

  
}

@media screen and (min-width: 1081px) and (max-width: 1366px) { 
  // background: var(--third-color);

  .contact {

    &__title {
      
    }
    &__data {
      grid-template-columns: 1fr 1fr;
      margin: 0 0rem;
      gap: 10rem;
      &__description {
        display: flex;
         max-width: 100%;

        flex-direction: column;
        gap: 0rem;
        width: 300%;
        margin-bottom: 6rem;

        }
      }
      &__form {
        background: var(--third-color);

        margin-bottom: 4rem;
        border: 1px solid green;
        .div{
          background: var(--third-color);
          height: 300px;
        }
        }
      }
    }
`;

export default ContactKnife;
